(function () {
  const FREE_GIFT_VARIANT_ID = 43545213993166; // producto regalo
  const FREE_GIFT_THRESHOLD  = 400000; // COP
  const FREE_GIFT_PROP       = '_free_gift';
  const SESSION_KEY          = 'freeGiftJustChanged';
  let   giftBusy             = false;

  function isGiftItem(item) {
    return item.variant_id === FREE_GIFT_VARIANT_ID &&
           item.properties && item.properties[FREE_GIFT_PROP] === 'true';
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());
  }

  function refreshUI(updatedCart) {
    if (window.halo && typeof halo.updateSidebarCart === 'function') {
      halo.updateSidebarCart(updatedCart);
    }
    if (window.location.pathname === '/cart') {
      sessionStorage.setItem(SESSION_KEY, '1');
      window.location.reload();
    }
  }

  async function checkFreeGift(cart) {
    if (giftBusy) return;
    if (!cart || !Array.isArray(cart.items)) return;

    const giftItem        = cart.items.find(isGiftItem);
    const totalSinRegalo  = cart.items
      .filter(item => !isGiftItem(item))
      .reduce((sum, item) => sum + item.final_line_price, 0) / 100;

    const debeAgregar = totalSinRegalo >= FREE_GIFT_THRESHOLD && !giftItem;
    const debeQuitar  = totalSinRegalo <  FREE_GIFT_THRESHOLD &&  giftItem;

    if (!debeAgregar && !debeQuitar) return;

    giftBusy = true;
    try {
      let updatedCart;
      if (debeAgregar) {
        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({
            id: FREE_GIFT_VARIANT_ID,
            quantity: 1,
            properties: { [FREE_GIFT_PROP]: 'true' }
          })
        });
        await addRes.json();
        if (!addRes.ok) return;
        updatedCart = await fetchCart();
      } else {
        const freshCart = await fetchCart();
        const freshGift = freshCart.items.find(isGiftItem);
        if (!freshGift) return;
        const changeRes  = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: freshGift.key, quantity: 0 })
        });
        updatedCart = await changeRes.json();
      }
      refreshUI(updatedCart);
    } catch (e) {
      console.warn('[free-gift] error:', e);
    } finally {
      giftBusy = false;
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (sessionStorage.getItem(SESSION_KEY)) {
      sessionStorage.removeItem(SESSION_KEY);
      return;
    }
    fetchCart().then(cart => checkFreeGift(cart));
  });

  document.addEventListener('cart-update', (e) => {
    if (!giftBusy) checkFreeGift(e.detail);
  });
})();
